exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-field {\r\n    margin-left: 5px;\r\n    margin-top: 15px;\r\n    width :100%;\r\n}\r\n\r\n.action-buttons-edit {\r\n    margin-left: 146px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/Uhm.Loops.Web/src/app/collateralskillsets/collateralskillset-edit/collateralskillset-edit.component.css
// module id = ../../../../../src/app/collateralskillsets/collateralskillset-edit/collateralskillset-edit.component.css
// module chunks = main